//上科定制
/**
 * 搜索页获取课程列表
 */
API.techReqSearchCourseList = (data) => ajax.get(`/learn/shanghai/tech/get/course`, data)
/**
 * 当前学生是否选课
*/
API.techReqIsCourseSelected = (courseId) => ajax.get(`/learn/shanghai/tech/have/role/curriculum/outline?courseId=${courseId}`)